<template>
    <customer-layout>
        <div class="pb-12 bg-gray-100">
            <div class="px-8">
                <div class="py-10 mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div v-if="$page.props.jetstream.canUpdateProfileInformation">
                        <update-profile-information-form :user="$page.props.user" />

                        <jet-section-border />
                    </div>

                    <div v-if="$page.props.jetstream.canUpdatePassword">
                        <update-password-form class="mt-10 sm:mt-0" />

                        <jet-section-border />
                    </div>


                    <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />

                    <div class="py-16 border-t border-b border-green-600 divide-solid">
                        <a href="/logout" class="block px-8 py-2 mx-auto mt-2 text-xs font-semibold tracking-widest text-center text-white uppercase transition duration-150 ease-in-out bg-green-700 border border-transparent rounded-md hover:bg-green-800 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray">
                            Logout
                        </a>
                    </div>


                    <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                        <jet-section-border />

                        <delete-user-form class="mt-10 sm:mt-0" :user="$page.props.user"/>
                    </template>
                </div>
            </div>
        </div>
    </customer-layout>
</template>

<script>
    import DeleteUserForm from './DeleteUserForm'
    import JetSectionBorder from '@/Jetstream/SectionBorder'
    import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
    import UpdatePasswordForm from './UpdatePasswordForm'
    import UpdateProfileInformationForm from './UpdateProfileInformationForm'
    import CustomerLayout from '@/Layouts/CustomerLayout.vue';
    
    
    export default {
        props: ['sessions'],

        components: {
            DeleteUserForm,
            JetSectionBorder,
            LogoutOtherBrowserSessionsForm,
            UpdatePasswordForm,
            UpdateProfileInformationForm,
            CustomerLayout
        },
    }
</script>
